import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY } from '@constant/colors';

const Youtube = ({ width }) => (
  <svg width={width} height={width} viewBox="0 0 24 17">
    <path
      d="M23.723 3.665S23.49 2 22.771 1.267C21.86.305 20.838.3 20.37.244 17.016 0 11.986 0 11.986 0h-.01s-5.03 0-8.384.244c-.467.056-1.49.061-2.4 1.023C.474 2 .239 3.665.239 3.665S0 5.618 0 7.573v1.833c0 1.955.24 3.908.24 3.908s.234 1.664.952 2.397c.912.963 2.109.932 2.641 1.034 1.917.184 8.148.243 8.148.243s5.035-.007 8.39-.253c.469-.057 1.49-.061 2.4-1.024.718-.733.952-2.397.952-2.397s.24-1.955.24-3.908V7.573c0-1.955-.24-3.908-.24-3.908zm-14.217 7.96V4.84l6.475 3.405-6.475 3.38z"
      fillRule="evenodd"
      fill={OSLO_GRAY}
    />
  </svg>
);

Youtube.propTypes = {
  width: PropTypes.number,
};

Youtube.defaultProps = {
  width: 20,
};

export default Youtube;
